import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SmoothScrollProvider } from './contexts/SmoothScrollContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Viaggi from './pages/Viaggi';
import ArticoloSingolo from './pages/ArticoloSingolo';
import About from './pages/About';
import Collaborazioni from './pages/Collaborazioni';
import Consulenza from './pages/Consulenza';
import Contatti from './pages/Contatti';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TerminiCondizioni from './pages/TerminiCondizioni';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <SmoothScrollProvider>
        <div className="App">
          <div className="grain-overlay" />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="viaggi" element={<Viaggi />} />
                <Route path="viaggi/:slug" element={<ArticoloSingolo />} />
                <Route path="about" element={<About />} />
                <Route path="collaborazioni" element={<Collaborazioni />} />
                <Route path="consulenza" element={<Consulenza />} />
                <Route path="contatti" element={<Contatti />} />
                <Route path="admin" element={<AdminLogin />} />
                <Route path="admin/dashboard" element={<AdminDashboard />} />
                <Route path="privacy-policy" element={<PrivacyPolicy />} />
                <Route path="termini-condizioni" element={<TerminiCondizioni />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </SmoothScrollProvider>
    </AuthProvider>
  );
}

export default App;